import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeUrl } from '@angular/platform-browser';
import { FeaturesService } from 'app/modules/main/services/features.service';
import { of } from 'rxjs';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-secure-image',
  templateUrl: './secure-image.component.html',
})
export class SecureImageComponent implements OnInit {

  @Input() readonly alt: string = '';
  @Input() readonly src: string = '';
  @Input() readonly fallbackSrc: string = '';

  private _imgUrl: Observable<SafeUrl | string>;

  get imgUrl(): Observable<SafeUrl | string> {
    return this._imgUrl;
  }

  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly featuresService: FeaturesService,
    private readonly http: HttpClient,
  ) {
  }

  ngOnInit(): void {

    if (this.featuresService.previewCaptureEnabled
      && this.src?.length) {

      this._imgUrl =
        this.http
          .get(this.src, { responseType: 'blob' })
          .pipe(
            map(blob => URL.createObjectURL(blob)),
            map(url => this.domSanitizer.bypassSecurityTrustUrl(url)),
            catchError(() => of(this.fallbackSrc)),
          );

    } else {
      this._imgUrl = of(this.fallbackSrc);
    }
  }
}
